import React from 'react';
import PropTypes from 'prop-types';
import CaretRight from 'core/icons/CaretRight';
import styled, { css } from 'styled-components';
import { getColor, typeScale } from 'core/utils';
import { resetBtn, size, align } from 'styled-manila';
import { StyleVars } from 'core/utils/Styles';


const NavBtn = styled.button`
	${resetBtn};
	${size(48)};
	background-color: ${getColor('primaryBrand')};
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	border: 4px solid ${getColor('white')};
	box-shadow: 0 2px 4px 0 rgba(74, 74, 74, 0.30);
	z-index: 2;
	transition: 0.3s;
	opacity: 1;

	@media (max-width: ${StyleVars.screenSm}) {
		display: none;
	}

	${({ center }) => center && align('vertical')};

	${({ center, left }) => center && left && css`
		left: ${left};
	`};

	${({ center, right }) => center && right && css`
		right: ${right};
	`};

	${({ hide }) => hide && css`
		opacity: 0;
		pointer-events: none;
	`}

	&:hover, &:active {
		background: ${getColor('primaryBrandHover')};
		box-shadow: 0 0 6px 0 rgba(74, 74, 74, 0.30);
	}

	svg {
		fill: ${getColor("white")};
		stroke: ${getColor("white")};
		width: 11px;
		height: 16px;
		${({ flip }) => flip && css`
			transform: rotate(180deg);
		`}
	}
`;

const CaretBtn = ({ alt, ...props }) => (
	<NavBtn aria-label={alt} {...props}>
		<CaretRight width="11" height="16" />
	</NavBtn>
);

CaretBtn.propTypes = {
	hide: PropTypes.bool,
	flip: PropTypes.bool,
	alt: PropTypes.string,
	center: PropTypes.bool,
	left: PropTypes.string,
	right: PropTypes.string,
};

CaretBtn.defaultProps = {
	alt: "Care Button"
};

export default CaretBtn;
